export const CredentialShareSuccessStyles = {
    page: "relative mx-auto flex w-full max-w-2xl flex-col items-center px-4 py-10 sm:py-14",
    successIconWrapper: "flex h-20 w-20 items-center justify-center rounded-full bg-[#ECFDF3]",
    title: "mt-5 text-center text-xl font-bold text-[#000000]",
    subtitle: "mt-2 text-center text-[14px] text-[#000000]",
    summaryCard:
        "mt-8 rounded-2xl border border-[#E5E7EB] bg-white p-5 shadow-sm",
    verifierRow: "flex items-start justify-between gap-3",
    verifierInfo: "flex min-w-0 items-start gap-3",
    verifierLogoWrapper:
        "flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-[#E2E8F0] bg-[#F8FAFC] p-1.5",
    verifierLogo: "h-full w-full object-contain",
    verifierName: "text-base font-semibold text-[#0F172A] break-words",
    trustedBadge: "inline-flex items-center gap-2 text-[12px] font-normal text-[#2563EB]",
    timestamp: "shrink-0 pt-1 text-[12px] text-[#94A3B8]",
    divider: "my-4 border-t border-[#F1F5F9]",
    cardsSectionLabel:
        "text-[11px] font-semibold uppercase tracking-[0.08em] text-[#94A3B8]",
    credentialList: "mt-3 flex flex-col gap-2",
    credentialRow:
        "flex items-center w-full sm:w-[360px] gap-3 rounded-xl border border-[#F1F5F9] bg-[#F9FAFB] px-3 py-2.5",
    credentialLogoWrapper:
        "flex h-9 w-9 shrink-0 items-center justify-center overflow-hidden rounded-full border border-[#E2E8F0] bg-white",
    credentialLogo: "h-full w-full object-cover",
    credentialName: "min-w-0 flex-1 truncate text-sm font-medium text-[#0F172A]",
    credentialCheck: "h-5 w-5 shrink-0 text-[#22C55E]",
    returnButton: "mt-6 h-12 w-full max-w-full sm:w-[408px] rounded-full text-sm font-semibold mr-0",
};
